import * as React from 'react';

import { CoworkingWorkplacesCount } from '../../../../components/Commercial/CoworkingWorkplacesCount';
import { useOfferContext } from '../../../../context';
import { ECoworkingOfferType } from '../../../../types/offer';

const SUPPORTED_TYPES = new Set<ECoworkingOfferType>([
  ECoworkingOfferType.FixedWorkplace,
  ECoworkingOfferType.FlexibleWorkplace,
]);

export function CoworkingWorkplacesCountContainer() {
  const { offer } = useOfferContext();
  const { coworkingOfferType, workplaceCount } = offer;

  if (!coworkingOfferType || !SUPPORTED_TYPES.has(coworkingOfferType)) {
    return null;
  }

  return <CoworkingWorkplacesCount coworkingOfferType={coworkingOfferType} workplaceCount={workplaceCount ?? null} />;
}

CoworkingWorkplacesCountContainer.displayName = 'CoworkingWorkplacesCountContainer';
